<template>
  <div class="p-col-12 p-md-10 p-lg-11 newsletter-wrapper">
    Cutting boards
  </div>
</template>

<script>

export default {
  name: 'CuttingBoardsView',
  setup (props) {
  }
}
</script>

<style lang="scss" scoped>
body{
  background-color: $light_grey;
}
</style>
